import css from 'styled-jsx/css';
import { serif, sansSerif } from 'styles/css-constants';

export default css`
  .AmpRecipeRoundupNav :global(.Post__recipeRoundupNav--yellowButtons) {
    margin-bottom: 1.5rem;
    padding: 0 0 1rem;
  }

  .AmpRecipeRoundupNav :global(.Post__recipeRoundupNav--yellowButtons::before) {
    content: 'Jump to Section';
    margin: 0 0 0.5rem;
    display: block;
    color: #705e5d;
    font-family: ${sansSerif};
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }

  .AmpRecipeRoundupNav :global(.Post__recipeRoundupNav--yellowButtons a) {
    display: block;
    border-bottom: 1px solid #fff;
    padding: 0.5rem;
    background-color: #fcd110;
    color: #321917;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    text-decoration: none;
  }

  .AmpRecipeRoundupNav :global(.Post__recipeRoundupNav--yellowButtons li) {
    margin: 0;
    padding: 0;
    font-family: ${sansSerif};
    font-size: 16px;
    text-align: center;
  }

  .AmpRecipeRoundupNav :global(.Post__recipeRoundupNav--yellowButtons ul) {
    margin: 0;
    padding: 0;
    list-style: none;
    display: block;
  }
`;
